import { render, staticRenderFns } from "./QuizFormContent.vue?vue&type=template&id=267ac951"
import script from "./QuizFormContent.vue?vue&type=script&lang=js"
export * from "./QuizFormContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports